"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChildren = void 0;
var react_1 = __importDefault(require("react"));
exports.StyledChildren = function (props) {
    var classnames = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.filter(function (a) { return a !== undefined; }).join(' ');
    };
    var styledChildren = react_1.default.Children.map(props.children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                className: classnames(child.props.className, props.className)
            });
        }
        return child;
    });
    return react_1.default.createElement(react_1.default.Fragment, null, styledChildren);
};
